import { UrlContext } from '@/context/UrlContext';
import { useContext } from 'react';

export const useUrl = () => useContext(UrlContext);
